module.exports = __webpack_public_path__ + "img/58063e9dc91cde3b3d7210348980285b.png";